/**
 * Subdomain-based tenant detection. Returns the leftmost label of the hostname
 * uppercased, unless it's a reserved environment / infrastructure label.
 *
 * Examples:
 *   acme.kuntur.com.pe        → "ACME"
 *   acme.dev.kuntur.com.pe    → "ACME"
 *   dev.kuntur.com.pe         → null  (env-only landing)
 *   demo.kuntur.com.pe        → null
 *   kuntur.com.pe             → null  (root, no tenant)
 *   localhost                 → null  (dev fallback to manual entry)
 */
const RESERVED_SUBDOMAINS = new Set(['localhost', 'www', 'dev', 'demo', 'staging', 'api', 'static', 'kuntur'])

export function getTenantCodeFromSubdomain(): string | null {
  if (typeof window === 'undefined') return null
  const host = window.location.hostname.split(':')[0]
  if (!host) return null

  const labels = host.split('.')
  if (labels.length < 3) return null

  const firstLabel = labels[0].toLowerCase()
  if (RESERVED_SUBDOMAINS.has(firstLabel)) return null
  return firstLabel.toUpperCase()
}
